<template>
  <div v-if="detail" class="rank">
    <div class="title" :style="detail.bgstyle">投票排名</div>
    <div class="info">
      <div class="num">
        已参与
        <div class="number">{{ total }}</div>
        人
      </div>
    </div>

    <div class="search-area">
      <van-search
        show-action
        placeholder="搜索姓名、手机号、项目、参赛单位"
        @search="onSearch"
        @focus="onSearch"
      >
        <template #action>
          <div @click="onSearch"> <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220422/1650623632/532962.png" />筛选</div>
        </template>
      </van-search>
      <!-- <van-field v-model="keywords" placeholder="搜索姓名、手机号、项目、参赛单位">
        <template #button>
          <van-button size="small" type="info" icon="search" @click="search" :color="detail.bgstyle.background"></van-button>
        </template>
      </van-field> -->
    </div>
    <div class="list-area">
      <van-tabs v-model="active" :color="detail.bgstyle.background">
        <van-tab title="全部选手"></van-tab>
        <van-tab title="投票排行"></van-tab>
      </van-tabs>
      <List v-if="rankList.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getRankList">
        <Row :gutter="16" class="list">
          <Col v-for="(item, index) in rankList" :key="index" span="12">
            <div
              @click="
                goDetail({
                  name: 'sportsResultVote',
                  params: $route.params,
                  query: { id: item.id },
                })
              "
              class="item"
            >
              <div class="cover">
                <div v-if="+media_type===3" class="text">{{item.mediaurl||''}}</div>
                <img v-else :src="item.mediaurl | videoposter" />
                <van-tag class="tag" mark type="primary" :color="detail.bgstyle.background">拉票 </van-tag>
              </div>
              <div class="info">
                <div class="name">{{ item.name || item.nickname }}</div>
                <van-button
                  class="btn"
                  :plain="!item.isvote"
                  :disabled="item.isvote"
                  size="small"
                  :color="detail.bgstyle.background"
                  @click.stop="vote(item)"
                >
                  <div class="btn-area">
                    <div>
                      <span v-if="item.isvote">已投</span>
                      <van-icon v-else name="like" />
                    </div>
                    <span style="margin-left:.5rem">|</span>
                    <div style="margin-left:.5rem">{{ item.score * 1 }}</div>
                  </div>
                </van-button>
              </div>
            </div>
          </Col>
        </Row>
      </List>
      <Empty v-else description="暂无数据" />
    </div>
    <van-popup v-model="isshow" closeable position="right" :style="{ height: '100%',width: '100%' }">
      <div class="pop">
        <div class="p-title">全部项目</div>
        <div class="i-list">
          <div v-for="item in prolist" :key="item.key" :class="['i-item',sactive==item.key?'active':'']" @click="changeFilters(item)">{{item.value}}</div>
        </div>
        <div class="p-title">参赛单位</div>
        <van-field v-model="contestant" placeholder="请输入参赛单位" />
        <div class="p-title">姓名或手机号</div>
        <van-field v-model="keywords" placeholder="请输入姓名或手机号" />
        <div class="btn-area">
          <div class="btn">
            <van-button color="#1A9DFE" size="small" round plain block type="info" @click="clear">重置</van-button>
          </div>
          <div class="btn">
            <van-button color="#1A9DFE" size="small" round block type="info" @click="search">确认</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
.pop {
  height: 100vh;
  padding: .3rem;
  position: relative;
  .p-title {
    display: flex;
    align-items: baseline;
    font-size: .36rem;
    color: #333;
    font-weight: bold;
    position: relative;
    // margin-bottom: .3rem;
  }
  .i-list{
    margin-bottom: .2rem;
    .i-item {
      display: inline-block;
      margin:0 .1rem;
      // padding: .12rem .3rem;
      width: 2rem;
      height: .6rem;
      border-radius: .04rem;
      font-size: .24rem;
      color: #1E385B;
      background: #F6FAFA;
      transition: all 0.2s;
      text-align: center;
      line-height: .6rem;
    }
    .active {
      background: #1A9DFE;
      color: #fff;
      transition: all 0.2s;
    }
  }
  .btn-area {
    margin-top: .32rem;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn {
      width: 2.6rem;
    }
  }
}

.rank {
  background: #fff;
  padding-top: 0.2rem;

  .vhtml {
    padding-top: 1.2rem;

    /deep/ img {
      max-width: 100%;
    }
  }

  .title {
    margin: 0 auto;
    width: 1.6rem;
    height: 0.35rem;
    background: #1a9dfe;
    font-size: 0.36rem;
    padding: 0.1rem 0.45rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0.12rem 0 0.12rem;
  }

  .info {
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.14rem 0;

    > div {
      padding: 0rem 0.3rem;
    }

    .num {
      color: #333;
      display: flex;
      border-right: 1px solid #eee;

      .number {
        color: #1a9dfe;
        padding: 0 0.04rem;
        font-family: sans-serif;
        font-weight: bold;
      }
    }

    .rule {
      color: #999;
      display: flex;
      align-items: center;
    }
  }

  .search-area {
    .van-search{
      /deep/ .van-search__content{
        border-radius: .32rem;
      }
      /deep/ .van-search__action{
        box-sizing: border-box;
        background: #1a9dfe;
        border-radius: .32rem;
        width: 1.56rem;
        font-size: .28rem;
        color: #FFFFFF;
        font-weight: 400;       
        margin-left: .2rem;
        >div{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img{
          width:.4rem;
          height: .4rem;
        }
      }
    }
    
    .van-cell.van-field {
      /deep/ .van-field__body {
        background: #f6f6f6;
        padding: 0 0 0 0.08rem;
      }
    }
  }

  .list {
    padding: 0.3rem 0.15rem;
    background: #f6f6f6;

    .item {
      background: #fff;
      margin-bottom: 0.32rem;
      display: inline-block;
      width: 100%;

      .cover {
        width: 100%;
        height: 2.4rem;
        position: relative;

        .tag {
          position: absolute;
          top: 0.12rem;
          left: 0;
        }

        .text{
          width: 100%;
          height: 2.4rem;
          font-size: .24rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name {
        font-size: 0.28rem;
        padding: 0.1rem 0;
        height: .3rem;
      }

      .info {
        padding: 0 0.2rem 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .btn {
          width: 100%;

          .btn-area {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
        }
      }
    }
  }
}
</style>

<script>
import { Tabs, Tab, Button, Field, Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Tag, Search, Popup } from 'vant'

export default {
  computed: {
    buttonColor() {
      let detail = this.detail
      if (!detail) return '#ccc'
      return `${detail.tabstyle[0]['color']}`
    },
  },
  watch: {
    active(val) {
      this.rankList = []
      this.page = 1
      this.finished = false
      this.$nextTick(() => {
        this.getRankList()
      })
    },
  },
  components: {
    vanField: Field,
    vanButton: Button,
    vanTab: Tab,
    vanTabs: Tabs,
    vanTag: Tag,
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
    vanSearch: Search,
    vanPopup: Popup
  },
  props: ['item_sub_id', 'sports_id','item_id'],
  data() {
    return {
      content: '',
      show: false,
      keywords: '',
      rankList: [],
      loading: false,
      finished: false,
      detail: '',
      page: 1,
      total: 0,
      systime: '',
      myinfo: '',
      active: 0,
      media_type: 1,
      isshow: false,
      sactive: '',
      prolist: [
        {"key":1,"value":"篮球"},
        {"key":2,"value":"排球"},
        {"key":3,"value":"田径"},
        {"key":4,"value":"乒乓球"},
        {"key":5,"value":"羽毛球"},
        {"key":6,"value":"网球"},
        {"key":7,"value":"体操（艺术体操）"},
        {"key":8,"value":"击剑"},
        {"key":9,"value":"射箭"},
        {"key":10,"value":"棒垒球"},
        {"key":11,"value":"高尔夫球"},
        {"key":12,"value":"橄榄球"},
        {"key":13,"value":"攀岩"},
        {"key":14,"value":"武术"},
        {"key":15,"value":"拳击"},
        {"key":16,"value":"跆拳道"},
        {"key":17,"value":"马术"},
        {"key":18,"value":"冰雪"},
        {"key":19,"value":"滑板"},
        {"key":20,"value":"空手道"}
      ],
      project: '',
      contestant: ''
    }
  },
  methods: {
    clear() {
      this.project = ''
      this.contestant = ''
      this.keywords = ''
    },
    changeFilters(row) {
      if(this.sactive != row.key){
        this.sactive = row.key
        this.project = row.value
      } else {
        this.project =  ''
        this.sactive = ''
      }
    },
    onSearch() {
      this.isshow = true
    },
    goDetail(query) {
      this.$router.push(query)
    },
    vote(row) {
      // if (row.isvote) {
      //   return
      // }
      this.$api.sports
        .vote({
          mcloud_sports_item_user_id: row.id,
        })
        .then((r) => {
          this.search();
        })
    },
    search() {
      this.isshow = false
      this.page = 1;
      this.rankList = []
      this.getRankList()
    },
    getRankList: function() {
      let sort = 1
      if (this.active == 1) {
        sort = 2
      }
      let query = Object.assign(
        {},
        {
          project: this.project,
          contestant: this.contestant,
          cpgid: this.item_sub_id,
          page: this.page,
          keywords: this.keywords,
          sort: sort,
        }
      )

      this.$api.sports.compareRank(query).then((res) => {
        this.systime = res.sys_time
        this.loading = false
        let { list, page, pages, myinfo, total,alltotal, content, rules, media_type } = res.data
        this.content = rules
        this.myinfo = myinfo
        this.total = alltotal
        this.media_type = media_type
        list.forEach((item, index) => {
          if (index > 0 && +item.score === +list[index - 1]['score']) {
            item.rank = list[index - 1]['rank']
          } else if (index === 0) {
            if (this.rankList.length) {
              let last = this.rankList[this.rankList.length - 1]
              if (+item.score === +last.score) {
                item.rank = last.rank
              } else {
                item.rank = last['rank'] * 1 + 1
              }
            } else {
              item.rank = 1
            }
          } else {
            item.rank = list[index - 1]['rank'] * 1 + 1
          }
          item.isvote = false
          // if (item.urid == myinfo.myvote) {

           for(var i in myinfo.myvote){
             if(myinfo.myvote[i] == item.urid){
                 item.isvote = true
                 return
             }
           }

        })
        this.rankList = this.rankList.concat(list)
        if (page >= pages) this.finished = true
        else this.page++
      })
    },
    init: function() {
      this.$toast.loading({
        duration: 0,
      })
      let params = { cpgid: this.item_sub_id }
      this.$api.sports.sportsMain(this.sports_id).then((res) => {
        let { bgstyle, id, tabstyle, introstyle, title } = res.data
        try {
          bgstyle = JSON.parse(bgstyle)
          tabstyle = JSON.parse(tabstyle)
          introstyle = JSON.parse(introstyle)
        } catch (e) {
          console.error(e)
        }
        this.detail = { id, bgstyle, tabstyle, introstyle, title }
        this.$toast.clear()
      })
    },
  },
  mounted() {
    this.init()
    this.getRankList()
  },
}
</script>
